import AppBloc from './blocs/app.bloc';
import AppBarBloc from './blocs/appBar.bloc';
import CaseDetailsBloc from './blocs/caseDetails.bloc';
import CasesBloc from './blocs/cases.bloc';
import CreateCaseBloc from './blocs/createCase.bloc';
import CreatePasswordBloc from './blocs/createPassword.bloc';
import CreateWorkSpaceBloc from './blocs/createWorkSpace.bloc';
import CreatorsBloc from './blocs/creators.bloc';
import DowngradeBloc from './blocs/downgrade.bloc';
import DownloadBloc from './blocs/download.bloc';
import EditWorkspaceBloc from './blocs/editworkspace.bloc';
import LoginBloc from './blocs/login.bloc';
import MyAccountBloc from './blocs/myAccount.bloc';
import PatientAccountBloc from './blocs/patientAccount.bloc';
import PatientDashboardBloc from './blocs/patientDashboard.bloc';
import PatientListBloc from './blocs/patientList.bloc';
import PatientReportBloc from './blocs/patientReport.bloc';
import PaymentBloc from './blocs/payment.bloc';
import PaymentRedirectResultBloc from './blocs/paymentRedirectResult.bloc';
import PersonalizedVideoReportBloc from './blocs/personalizedVideoReport.bloc';
import RegisterBloc from './blocs/register.bloc';
import ReportViewerBloc from './blocs/report-viewer.bloc';
import ResendInviteBloc from './blocs/resendInvite.bloc';
import ResourcesBloc from './blocs/resources.bloc';
import SnackbarAppBloc from './blocs/snackbarApp.bloc';
import UpgradePlanBloc from './blocs/upgradePlan.bloc';
import UploadProgressBloc from './blocs/upload-progress.bloc';
import VideoRequestBloc from './blocs/videoRequest.bloc';
import ViewerBloc from './blocs/viewer.bloc';
import WorkspacesBloc from './blocs/workspaces.bloc';
import AdminRepository from './repositories/admin.repository';
import AuthRepository from './repositories/auth.repository';
import CasesRepository from './repositories/cases.repository';
import CreatorRepository from './repositories/creator.repository';
import MaterialRepository from './repositories/material.repository';
import NotificationsRepository from './repositories/notifications.repository';
import PatientRepository from './repositories/patient.repository';
import PaymentRepository from './repositories/payment.repository';
import ResourceRepository from './repositories/resource.repository';
import UploadProgressRepository from './repositories/upload-progress.repository';
import UserRepository from './repositories/user.repository';
import WorkspaceRepository from './repositories/workspace.repository';
import withErrorHandler, { blocErrorHandler } from './utils/withErrorHandler';

/**
 * IMPORTANT: DO NOT wrap AuthRepository and ErrorRepository
 */
export default () => {
  // error handlers for repositories and http requests
  withErrorHandler(UserRepository);
  withErrorHandler(AuthRepository);
  withErrorHandler(CasesRepository);
  withErrorHandler(AdminRepository);
  withErrorHandler(PatientRepository);
  withErrorHandler(CreatorRepository);
  withErrorHandler(WorkspaceRepository);
  withErrorHandler(PaymentRepository);
  withErrorHandler(PaymentRepository);
  withErrorHandler(NotificationsRepository);
  withErrorHandler(ResourceRepository);
  withErrorHandler(MaterialRepository);
  withErrorHandler(UploadProgressRepository);

  // error handlers for general exceptions and business logic
  blocErrorHandler(CreatePasswordBloc);
  blocErrorHandler(PersonalizedVideoReportBloc);
  blocErrorHandler(CasesBloc);
  blocErrorHandler(AppBloc);
  blocErrorHandler(AppBarBloc);
  blocErrorHandler(CaseDetailsBloc);
  blocErrorHandler(CasesBloc);
  blocErrorHandler(CreatePasswordBloc);
  blocErrorHandler(CreateWorkSpaceBloc);
  blocErrorHandler(CreatorsBloc);
  blocErrorHandler(DowngradeBloc);
  blocErrorHandler(DownloadBloc);
  blocErrorHandler(EditWorkspaceBloc);
  blocErrorHandler(CreateCaseBloc);
  blocErrorHandler(LoginBloc);
  blocErrorHandler(MyAccountBloc);
  blocErrorHandler(PatientAccountBloc);
  blocErrorHandler(PatientDashboardBloc);
  blocErrorHandler(PatientListBloc);
  blocErrorHandler(PaymentBloc);
  blocErrorHandler(PaymentRedirectResultBloc);
  blocErrorHandler(PersonalizedVideoReportBloc);
  blocErrorHandler(RegisterBloc);
  blocErrorHandler(ResendInviteBloc);
  blocErrorHandler(ResourcesBloc);
  blocErrorHandler(SnackbarAppBloc);
  blocErrorHandler(UpgradePlanBloc);
  blocErrorHandler(UploadProgressBloc);
  blocErrorHandler(VideoRequestBloc);
  blocErrorHandler(WorkspacesBloc);
  blocErrorHandler(ViewerBloc);
  blocErrorHandler(PatientReportBloc);
  blocErrorHandler(ReportViewerBloc);
};
